export default class CommonActivityType {
  code: number
  description: string

  constructor(data: CommonActivityType) {
    this.code = data.code
    this.description = data.description
  }
}
